module.exports = __webpack_public_path__ + "static/15-80c2b63a19636848a32ee738c129c960.jpg";